import React, { lazy, Suspense, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import allRoutes from "./data/routes";

//importing react responsive media queries
import { useMediaQuery } from "react-responsive";

//Protected Routes
import ProtectedRoute from "./Components/helpers/ProtectedRoute/ProtectedRoute";

//animation library
import Aos from "aos";
import "aos/dist/aos.css";

//Loader import
import Loader from "./Components/helpers/Loader/Loader";

//Main Components Imports
const Home = lazy(() => import("./Components/LandingPages/Home/Home"));
const About = lazy(() => import("./Components/LandingPages/About/About"));
const Contact = lazy(() => import("./Components/LandingPages/Contact/Contact"));
const Login = lazy(() => import("./Components/LandingPages/Login/Login"));
const Register = lazy(() =>
  import("./Components/LandingPages/Register/Register")
);
const Thankyou = lazy(() => import("./Components/helpers/Greeting/Thankyou"));

//exam cell module imports
const ExamCellLogin = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./Components/ExamCell/Login/Login")), 500);
  });
});

const ExamCellDashboard = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./Components/ExamCell/Main/Main")), 500);
  });
});

const ExamCellUpdateStudentList = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(import("./Components/ExamCell/UpdateStudentList/Update")),
      500
    );
  });
});

const ExamCellUpdateStudentExcelList = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () =>
        resolve(import("./Components/ExamCell/UpdateStudentList/UpdateExcel")),
      500
    );
  });
});

const ExamCellUpdateStudent = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(import("./Components/ExamCell/UpdateStudent/Update")),
      500
    );
  });
});

//class-cc module imports
// import ClassCCLogin from "./Components/ClassCC/Login";
const ClassCCLogin = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./Components/ClassCC/Login")), 500);
  });
});
const ClassCCRegister = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./Components/ClassCC/Signup")), 500);
  });
});
const ClassCCDashboard = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(import("./Components/ClassCC/Layout/Dashboard")),
      500
    );
  });
});
const ClassCCMentorSection = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(import("./Components/ClassCC/Layout/MentorSection")),
      500
    );
  });
});
const ClassCCStudentSection = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(import("./Components/ClassCC/Layout/StudentSection")),
      500
    );
  });
});
const ClassCCMessage = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(import("./Components/ClassCC/Layout/Message")),
      500
    );
  });
});
const ClassCCCounselling = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(import("./Components/ClassCC/Layout/Counselling")),
      500
    );
  });
});
const ClassCCProfile = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(import("./Components/ClassCC/Layout/Profile")),
      500
    );
  });
});
const ClassCCViewStudent = lazy(() =>
  import("./Components/ClassCC/Layout/ViewStudent")
);
const ClassCCViewMentor = lazy(() =>
  import("./Components/ClassCC/Layout/ViewMentor")
);

//mentor module imports
const MentorLogin = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./Components/Mentor/Login")), 500);
  });
});
const MentorRegister = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./Components/Mentor/Signup")), 500);
  });
});
const MentorDashboard = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(import("./Components/Mentor/Layout/Dashboard")),
      500
    );
  });
});
const MentorStudent = lazy(() => import("./Components/Mentor/Layout/Student"));
const MentorAddParents = lazy(() =>
  import("./Components/Mentor/Layout/AddParents")
);
const MentorProjectDetails = lazy(() =>
  import("./Components/Mentor/Layout/ProjectDetails")
);
const MentorMessage = lazy(() => import("./Components/Mentor/Layout/Messsage"));
const View = lazy(() => import("./Components/Mentor/Layout/View"));
const StuMessage = lazy(() => import("./Components/Mentor/Layout/StuMessage"));
const ParentMessage = lazy(() =>
  import("./Components/Mentor/Layout/ParentMessage")
);
const MentorProfile = lazy(() => import("./Components/Mentor/Layout/Profile"));
const MentorCounselling = lazy(() =>
  import("./Components/Mentor/Layout/Counselling")
);
const MentorViewCounselling = lazy(() =>
  import("./Components/Mentor/Forms/CounsellingForm")
);

const MentorAllCounselling = lazy(() =>
  import("./Components/Mentor/pages/Counselling/AllCounsellings")
);

//Student module imports
const StudentLogin = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./Components/Students/Login")), 500);
  });
});
const StudentRegister = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./Components/Students/Signup")), 500);
  });
});
const StudentDashboard = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(import("./Components/Students/Layout/DashBoard")),
      500
    );
  });
});

const StudentAcademic = lazy(() =>
  import("./Components/Students/Layout/Academic")
);
const StudentAchievement = lazy(() =>
  import("./Components/Students/Layout/Achievement")
);
const StudentProfile = lazy(() =>
  import("./Components/Students/Layout/Profile")
);
const StudentSemester = lazy(() =>
  import("./Components/Students/Layout/Semester")
);
const StudentMessage = lazy(() =>
  import("./Components/Students/Layout/Message")
);
const StudentCounselling = lazy(() =>
  import("./Components/Students/Layout/Counselling")
);
const StudentAllMessage = lazy(() =>
  import("./Components/Students/pages/AllMessages/AllMessages")
);
const StudentReplyMessage = lazy(() =>
  import("./Components/Students/pages/ReplyToMessage/ReplyToMessage")
);
const StudentForgotPassword = lazy(() =>
  import("./Components/Students/ForgotPassword")
);
const StudentResetPassword = lazy(() =>
  import("./Components/Students/ResetPassword")
);
const Page404 = lazy(() => import("./Components/helpers/404Page/Page404"));

function App() {
  useEffect(function () {
    Aos.init({ duration: 1500 });
  }, []);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Landing Main Pages */}
        <Route path={allRoutes.homepage} element={<Home />} />
        <Route path={allRoutes.page404} element={<Page404 />} />
        <Route path={allRoutes.aboutPage} element={<About />} />
        <Route path={allRoutes.contactPage} element={<Contact />} />
        <Route path={allRoutes.allLoginPage} element={<Login />} />
        <Route path={allRoutes.allRegisterPage} element={<Register />} />
        <Route path={allRoutes.commonThankyou} element={<Thankyou />} />

        {/* exam cell modules */}
        <Route
          path={allRoutes.examCellDashboard}
          element={<ExamCellDashboard />}
        />
        <Route path={allRoutes.examCellLogin} element={<ExamCellLogin />} />
        <Route
          path={allRoutes.examCellUpdateStudentList}
          element={<ExamCellUpdateStudentList />}
        />
        <Route
          path={allRoutes.examCellUpdateStudentExcelList}
          element={<ExamCellUpdateStudentExcelList />}
        />
        <Route
          path={`${allRoutes.examCellEditStudent}/:recordId`}
          element={<ExamCellUpdateStudent />}
        />

        {/* unprotected routes here */}
        {/* mentor unprotected pages */}
        <Route path={allRoutes.mentorLogin} element={<MentorLogin />} />
        <Route path={allRoutes.mentorRegister} element={<MentorRegister />} />

        {/* student unprotected pages */}
        <Route path={allRoutes.studentLogin} element={<StudentLogin />} />
        <Route path={allRoutes.studentRegister} element={<StudentRegister />} />
        <Route
          path={allRoutes.studentForgotPassword}
          element={<StudentForgotPassword />}
        />
        <Route
          path={allRoutes.studentResetPassword}
          element={<StudentResetPassword />}
        />
        <Route path={allRoutes.ccLogin} element={<ClassCCLogin />} />
        <Route path={allRoutes.ccRegister} element={<ClassCCRegister />} />

        {/* Protected Routes only */}
        <Route element={<ProtectedRoute />}>
          {/* Class-CC protected Pages */}
          <Route path={allRoutes.ccDashboard} element={<ClassCCDashboard />} />
          <Route
            path={allRoutes.ccCounselling}
            element={<ClassCCCounselling />}
          />
          <Route path={allRoutes.ccMessage} element={<ClassCCMessage />} />
          <Route
            path={allRoutes.ccMentorSection}
            element={<ClassCCMentorSection />}
          />
          <Route
            path={allRoutes.ccStudentSection}
            element={<ClassCCStudentSection />}
          />
          <Route path={allRoutes.ccProfile} element={<ClassCCProfile />} />
          <Route
            path={`${allRoutes.ccViewStudent}/:recordId`}
            element={<ClassCCViewStudent />}
          />
          <Route
            path={`${allRoutes.ccViewMentor}/:recordId`}
            element={<ClassCCViewMentor />}
          />

          {/* Mentor protected Pages */}

          <Route
            path={allRoutes.mentorDashboard}
            element={<MentorDashboard />}
          />
          <Route
            path={allRoutes.mentorCounselling}
            element={<MentorCounselling />}
          />
          <Route path={allRoutes.mentorProfile} element={<MentorProfile />} />
          <Route path={allRoutes.mentorMessage} element={<MentorMessage />} />
          <Route
            path={allRoutes.mentorProjectDetails}
            element={<MentorProjectDetails />}
          />
          <Route path={allRoutes.StuMessage} element={<StuMessage />} />
          <Route path={allRoutes.ParentMessage} element={<ParentMessage />} />
          <Route
            path={`${allRoutes.mentorViewStudent}/:recordId`}
            element={<View />}
          />
          <Route
            path={`${allRoutes.mentorAddParents}/:recordId`}
            element={<MentorAddParents />}
          />
          <Route
            path={`${allRoutes.mentorViewCounselling}/:recordId`}
            element={<MentorViewCounselling />}
          />
          <Route
            path={`${allRoutes.mentorAllCounselllings}`}
            element={<MentorAllCounselling />}
          />
          <Route
            path={allRoutes.mentorStudentSection}
            element={<MentorStudent />}
          />

          {/* Student protected Pages */}
          <Route
            path={allRoutes.studentDashboard}
            element={<StudentDashboard />}
          />
          <Route
            path={allRoutes.studentDashboard}
            element={<StudentDashboard />}
          />
          <Route
            path={allRoutes.studentAcademic}
            element={<StudentAcademic />}
          />
          <Route
            path={allRoutes.studentAllSemesterDetails}
            element={<StudentSemester />}
          />
          <Route
            path={allRoutes.studentAchievements}
            element={<StudentAchievement />}
          />
          <Route path={allRoutes.studentProfile} element={<StudentProfile />} />
          <Route path={allRoutes.studentMessage} element={<StudentMessage />} />
          <Route
            path={allRoutes.studentCounselling}
            element={<StudentCounselling />}
          />
          <Route
            path={allRoutes.studentAllMessages}
            element={<StudentAllMessage />}
          />
          <Route
            path={`${allRoutes.studentReplyMessage}/:recordId`}
            element={<StudentReplyMessage />}
          />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
